import { defineMessages } from 'react-intl';

export default defineMessages({
    error: {
        id: 'ml.cancellation.common.views.cancellation-contact-us.Error',
        defaultMessage: 'An error has occurred. Please try again later.'
    }
});